module.exports = __webpack_public_path__ + "098cbc10a31f1efe53ede4629778685b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/chh1.jpg
// module id = 302
// module chunks = 3